<template>
  <div id="app" :class="[companion ? 'companion' : 'connections']">
    <div v-if="!loadingFields">
      <IntegrationProfileHome :fullToken="fullToken" v-if="!instanceName" @brandingImageUrl="receiveImageUrl"
        @profileID="receiveProfileId" @update-language="updateLanguage" :isCompanion="companion" />
      <SelfSignupHome v-if="instanceName" />
      <div v-if="profileId" class="profileId">
        {{ profileId }}
      </div>
    </div>
    <LoadingUI class="mb-4" msg="Loading..." v-if="loadingFields" />
  </div>
</template>

<script>
import IntegrationProfileHome from './components/Integration-Profile/Home.vue'
import SelfSignupHome from './components/Self-Signup/Home.vue'
import config from './config'
import { translations } from './translations'
import { getFullToken } from './services/integration-profile-service'
import LoadingUI from './components/LoadingUI.vue'

export default {
  name: 'App',
  components: {
    LoadingUI,
    IntegrationProfileHome,
    SelfSignupHome
  },
  data() {
    return {
      instanceName: config.instance,
      language_id: 1,
      language: translations(),
      fullToken: "",
      loadingFields: false,
      profileImage: null,
      profileId: null,
      companion: config.companion
    }
  },
  async created() {
    let urlParams = window.location.search.split('token=');
    let token = urlParams[urlParams.length - 1];
    //check if token was shortened
    if (token.length < 10) {
      this.loadingFields = true;
      this.fullToken = await this.getToken(token);
    } else {
      this.fullToken = token;
    }
    if (this.fullToken != "") {
      const cachedToken = sessionStorage.getItem('token');
      if(cachedToken && cachedToken != this.fullToken) {
        //different QEL, clear selected staff cache
        sessionStorage.setItem("staffSelectedCached", null);
      }
      sessionStorage.setItem('token', this.fullToken);
    }
    this.loadingFields = false;
  },
  methods: {
    updateLanguage($event) {
      this.language_id = $event;
    },
    async getToken(abToken) {
      try {
        const response = await getFullToken(abToken);
        if (response.token) {
          return response.token;
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
      return "";
    },
    receiveImageUrl(data) {
      this.profileImage = data;
    },
    receiveProfileId(data) {
      this.profileId = data;
    }
  }
}
</script>

<style scoped>
.image-container {
  display: inline-flex;
  justify-content: space-between;
  max-width: 640px;
}

.profileId {
  text-align: left;
  color: lightgray;
  font-weight: bold;
  margin-top: 30px;
}
</style>

<style>
.companion{
  background: #54c870;
}

.connections{
  background: #dea7f5;
}
#app {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000;
  font-size: 14px;
  padding: 60px 20px;
  min-height: 100vh;
}
</style>
